export default class ScheduleResult {
    constructor(results) {
        this.start_nr = results.start_nr;
        this.order = results.order;
        this.finish_time = results.finish_time;
    }
}